<template>
  <div class="HomePage">
    <!-- <div id="app">
        <h1>{{ $t("message.hello") }}</h1>
        <button @click="changeLanguage('zh')">中文</button>
        <button @click="changeLanguage('ja')">日本語</button>
      </div> -->
    <div class="con_box">
      <div class="top_box">
        <div class="top_img" @click="toHome">
          <img src="../assets/logo.jpg" alt="" @click="toHome" />
        </div>
        <div class="top_rig">
          <div class="tab tab1">{{ $t("home.h2") }}</div>
          <div @click="tojieshao" class="tab">{{ $t("home.h3") }}</div>
          <div @click="toshiji" class="tab">{{ $t("home.h4") }}</div>
          <div @click="towenxun" class="tab">{{ $t("home.h5") }}</div>
          <!-- <select v-model="selectedOption" @change="handleChange">
            <option disabled value="">请选择</option>
            <option>中文</option>
            <option>日本語</option>
          </select> -->
        </div>
      </div>
      <div class="bg_img">
        <img src="../assets/bg.png" alt="" />
      </div>
      <div class="hudong_title">{{ $t("home.h2") }}</div>
      <div class="wenan">
        日中国際教育交流協会は、多角的な中日教育交流の促進にカを尽くしております。また、学術連携·協力の強化に全力で取り組んでおります。<br />
        <div class="yidong_img">
          <img src="../assets/1.jpg" alt="" />
        </div>

        同時に、中国の大学生を对象とした日本でのインタ一ンシップ・就職支援の総合プラットフオ一ムを構築しております。日本の企業との連携を通じて、経験の蓄積、専門技能の向上、日本の職場文化や業界動向への深い理解を可能とする機会を提供いたします。<br />
        <div class="yidong_img">
          <img src="../assets/2.jpg" alt="" />
        </div>
        中国の優秀な大学生を日本本土の企業に紹介し、実習実践を行い、それによって日本の企業文化を体験し、自身の専攻学習成果を検証いたします。
        <div class="yidong_img">
          <img src="../assets/3.jpg" alt="" />
        </div>
      </div>
      <div class="img_duo img_duo1">
        <img src="../assets/1.jpg" alt="" />
        <img src="../assets/2.jpg" alt="" />
        <img src="../assets/3.jpg" alt="" />
      </div>
      <div class="title2">
        <div>拠点提携</div>
        <div>上海赤門教育科学技術有限公司</div>
      </div>
      <div class="wenan">
        当協会は、中国の教育機関との連携にも力を注いでおります。上海赤門教育との長期的な提携を通じて、日中教育の交流を深化させてきました。<br />
        <div style="height: 20px"></div>
        これまで数多くの大学を訪問し、インターンシップや就職に関する説明会を開催してきました。日本の職場文化や就職事情、インターンシッププログラムの詳細を紹介し、学生たちの関心や疑問に丁寧に応えてきました。
      </div>
      <div class="img_duo">
        <img src="../assets/4.jpg" alt="" />
        <img src="../assets/5.jpg" alt="" />
        <img src="../assets/6.jpg" alt="" />
      </div>
      <!-- <div class="wenan">
        {{ $t("gai.g2") }}
      </div> -->
      <div class="title3">協会概要</div>
      <div class="img_x1">
        <img src="../assets/x2.png" alt="" />
      </div>
      <!-- <div class="biao">
        <div class="biao_le biao_le_1">{{ $t("home.h8") }}</div>
        <div class="biao_rig biao_rig_1">
          <div>{{ $t("home.h9") }}</div>
          <div>{{ $t("home.h10") }}</div>
        </div>
      </div>
      <div class="biao biao1">
        <div class="biao_le biao_le1 biao_le2">
          <div>{{ $t("home.h11") }}</div>
          <div>{{ $t("home.h12") }}</div>
        </div>
        <div class="biao_rig biao_rig1">
          <div>{{ $t("home.h13") }}</div>
        </div>
      </div>
      <div class="biao biao1">
        <div class="biao_le biao_le_3">{{ $t("home.h14") }}</div>
        <div class="biao_rig biao_rig_3">
          <div>{{ $t("home.h15") }}</div>
          <div>{{ $t("home.h16") }}</div>
        </div>
      </div>
      <div class="biao biao1" style="margin-bottom: 40px">
        <div class="biao_le biao4">{{ $t("home.h17") }}</div>
        <div class="biao_rig biao4_re">
          <div>{{ $t("home.h18") }}</div>
        </div>
      </div> -->
      <div class="footer">
        <div class="foo_con">
          <div class="fo_le">
            <img src="../assets/logo2.png" alt="" />
            <div class="fo_le_re">
              <div class="fo_top">{{ $t("home.h23") }}</div>
              <div class="fo_le_re_bo">
                <div @click="goToTop">{{ $t("home.h24") }}</div>
                <div>{{ $t("home.h25") }}</div>
                <div @click="tojieshao">{{ $t("home.h26") }}</div>
                <div @click="toshiji">{{ $t("home.h27") }}</div>
              </div>
            </div>
          </div>
          <div class="fo_re" @click="towenxun">{{ $t("home.h28") }}</div>
        </div>
        <div class="beian">{{ $t("home.h29") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  props: {
    msg: String,
  },
  data() {
    return {
      value1: 0,
      option1: [
        { text: "中文", value: 0 },
        { text: "日本語", value: 1 },
      ],
      selectedOption: "日本語",
    };
  },
  methods: {
    goToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    handleChange(event) {
      if (event.target.value == "日本語") {
        this.$i18n.locale = "ja";
      } else if (event.target.value == "中文") {
        this.$i18n.locale = "zh";
      }
    },
    toHome() {
      this.$router.push({ name: "HomePage" });
    },
    toGaiyao() {
      this.$router.push({ name: "GaiYao" });
    },
    tojieshao() {
      this.$router.push({ name: "JieShao" });
    },
    toshiji() {
      this.$router.push({ name: "ShiJi" });
    },
    towenxun() {
      this.$router.push({ name: "WenXun" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 700px) {
  .con_box,
  .top_box,
  .im_list,
  .foo_con,
  .wenan,
  .biao,
  .top_img {
    width: 100% !important;
  }
  .biao_rig {
    text-align: left !important;
  }
  .biao_le2 {
    margin-left: 0 !important;
    width: 104px !important;
  }
  .top_img img {
    width: 100% !important;
  }
  .biao_rig1 {
    margin-left: -9px !important;
  }
  .top_box,
  .img_box,
  .fo_le,
  .foo_con {
    flex-wrap: wrap;
    margin-bottom: 20px !important;
  }
  .HomePage {
    padding: 0 !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
  }
  .fo_le {
    justify-content: center;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .hudong_title {
    width: 40% !important;
    font-size: 16px !important;
    height: 40px !important;
  }
  .top_rig {
    gap: 10px !important;
    margin-top: 15px !important;
    font-size: 14px;
    margin: 0 auto;
  }
  .fo_le {
    justify-content: center;
  }
  .fo_le_re {
    align-items: center !important;
  }
  .im_list {
    margin-bottom: 20px !important;
  }
  .footer {
    padding-top: 0 !important;
  }
  .fo_le img {
    width: 100px !important;
    height: 100px !important;
  }
  .foo_con {
    flex-direction: column !important;
  }
  .fo_le {
    flex-direction: column !important;
    align-items: center !important;
    gap: 0 !important;
  }
  .fo_le_re_bo {
    margin-top: 20px !important;
  }
  .beian {
    margin-top: 0 !important;
  }
  .biao {
    width: 100% !important;
  }
  .biao4 {
    margin-left: -10px !important;
  }
  .biao4_re {
    margin-left: -34px !important;
  }
  .wenan {
    line-height: 30px !important;
    font-size: 16px !important;
    width: 90% !important;
  }
  .biao_rig_3 {
    margin-left: -30px !important;
  }
  .biao_le_3 {
    width: 165px !important;
  }
  .biao_le_1 {
    width: 111px !important;
  }
  .biao_rig_1 {
    margin-left: -10px !important;
  }
  .img_duo :nth-child(2) {
    height: 90px !important;
  }
  .img_duo {
    width: 100% !important;
  }
  .title2 {
    width: 100% !important;
    font-size: 19px !important;
    gap: 10px;
  }
  .img_x1 img {
    width: 100% !important;
  }
  .title3 {
    font-size: 19px !important;
  }
  .img_duo1 {
    display: none !important;
  }
  .yidong_img {
    display: block !important;
    width: 90% !important;
    margin: 10px auto !important;
  }
  .yidong_img img {
    width: 100% !important;
  }
}
.yidong_img {
  display: none;
}
.title2 {
  display: flex;
  gap: 30px;
  align-items: center;
  font-size: 24px;
  width: 75%;
  margin: 20px auto;
  font-weight: 600;
}
.title3 {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
}
.img_x1 {
  width: 100%;
  margin-bottom: 20px;
}
.img_x1 img {
  width: 77%;
}
.img_duo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 75%;
  margin: 30px auto;
}
.img_duo :nth-child(2) {
  height: 240px;
}
.img_duo img {
  width: 32%;
  height: 240px;
}
.wenan {
  line-height: 35px;
  margin-bottom: 20px;
  width: 75%;
  margin: 20px auto;
  text-align: left;
  font-size: 19px;
  /* color: #1e386b; */
}
.biao {
  width: 75%;
  margin: 0 auto;
  display: flex;
  gap: 50px;
  align-items: center;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 10px;
  box-sizing: border-box;
  border-top: 2px solid #000;
  border-bottom: 2px solid #000;
}
.biao1 {
  border-top: none !important;
}
.biao_le {
  font-size: 20px;
  width: 100px;
}
.biao_rig {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: baseline;
}
.biao_le1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: baseline;
}
.biao_le2 {
  margin-left: 10px;
  width: 90px;
}
/* css */
.hudong_title {
  width: 25%;
  height: 60px;
  font-size: 27px;
  border-radius: 30px;
  background-color: #1e386b;
  margin: 30px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.HomePage {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.con_box {
  width: 90%;
  margin: 0 auto;
}
.top_box {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_img {
  display: flex;
  gap: 0px;
  align-items: center;
}

.name_box {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: baseline;
}
.name_box :nth-child(1) {
  font-size: 22px;
  font-weight: 600;
}
.top_rig {
  display: flex;
  gap: 20px;
  align-items: center;
}
.tab1 {
  color: #1e386b;
  font-size: 20px;
  font-weight: 600;
}
.HomePage >>> .van-dropdown-menu__bar {
  width: 115px;
  height: 40px;
  /* box-shadow: none; */
}
.HomePage >>> .van-dropdown-item__content {
  /* right: 222px !important; */
  width: 116px;
}
.HomePage >>> .van-popup--top {
  right: 222px !important;
  left: auto;
}
.van-popup--top {
  right: 222px;
  left: auto;
}
.tab {
  cursor: pointer;
}
.footer {
  background-color: #153266;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
.fo_le_re_bo div {
  cursor: pointer;
}
.foo_con {
  width: 80%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
}
.fo_le {
  display: flex;
  gap: 40px;
}
.fo_le img {
  width: 200px;
  height: 200px;
}
.fo_le_re {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
}
.fo_top {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
}
.fo_le_re_bo {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #fff;
}
.fo_re {
  color: #fff;
  cursor: pointer;
}
.beian {
  text-align: center;
  margin-top: 70px;
  /* margin-bottom: 10px; */
  color: #fff;
}
select {
  width: 100px;
  height: 40px;
  box-shadow: 1px 2px 3px #999;
  border: none;
  text-align: center;
  outline: none;
}
.bg_img {
  width: 100%;
}
.bg_img img {
  width: 100%;
}
</style>
